import { useCallback } from "react";

import {
  EsignReminderStatus,
  useSendEsignReminderMutation,
} from "@covertree/agent-portal-graphql";
import { Toast } from "@covertree/utils";
import { getErrorMessageFromApolloError } from "@utils/getErrorMessageFromApolloError";

export const ONLY_ONE_REMINDER_MSG = "can only send one reminder";

export function useSendEsignReminder() {
  const [sendEsignReminder, { loading }] = useSendEsignReminderMutation();

  const sendEsignReminderHandler = useCallback(
    async (policyLocator: string) => {
      try {
        const { data } = await sendEsignReminder({
          variables: {
            policyLocator,
          },
          notifyOnNetworkStatusChange: true,
        });
        if (
          data?.sendEsignReminder?.esignReminderStatus ===
          EsignReminderStatus.Success
        )
          Toast.showSuccess("Esign reminder was sent successfully!");
        else
          Toast.showError(
            data?.sendEsignReminder?.message
              ?.toLowerCase()
              .includes(ONLY_ONE_REMINDER_MSG)
              ? "Cannot send more than one esign reminder per hour. Please try again later."
              : "Unable to send esign reminder. Please try again or contact us."
          );
      } catch (error) {
        Toast.showError(
          getErrorMessageFromApolloError(error) ??
            "Unable to send esign reminder. Please try again or contact us."
        );
      }
    },
    [sendEsignReminder]
  );

  return {
    sendEsignReminder: sendEsignReminderHandler,
    loading,
  };
}
